import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import { ReactComponent as IconTrending } from '@assets/Icon_Trending_Up.svg';
import { ReactComponent as IconInfo } from '@assets/Icon_Info.svg';


const Link = styled(
    ({ className, content, icon }) => {

        return (
            <div className={className}>
                {icon === "trending" && (<IconTrending className="svg" />)}
                {icon === "info" && (<IconInfo className="svg" />)}
                <span>
                    {content && content}
                </span>
            </div>
        )
    })`
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        color: var(--color-primary);

        display: inline-block;

        margin-right: 20px;

        span {
            line-height: 1.5rem;
        }
        
        .svg {
            margin-right: 1rem;
            width: calc(1.5rem);
            height: calc(1.5rem);
            margin-bottom: -0.3rem;
        }

    `

Link.Dashboard = () => <a href="https://dashboard.perlinx.finance/" target="_blank"><Link icon="trending" content="Dashboard" /></a>

Link.Info = ({ content }) => <Link content={content} icon="info" />

export default Link